
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 54 10"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#a)"}},[_c('path',{attrs:{"fill":"#008CFF","d":"M5.723.621c.2.41.328.906.328 1.635 0 1.332-.967 3.285-1.75 4.528L3.463.212 0 .532l1.586 9.236H5.54c1.732-2.22 3.865-5.381 3.865-7.815 0-.763-.164-1.367-.529-1.954zm9.536-.586c-3.609 0-5.36 3.055-5.36 5.932 0 2.22 1.077 3.996 4.084 3.996 1.185 0 2.406-.248 3.19-.621l.418-2.77c-1.112.55-1.968.763-2.861.763-.82 0-1.44-.426-1.44-1.51 1.86-.017 5.067-.763 5.067-3.197 0-1.51-1.111-2.593-3.098-2.593m-1.896 4.032c.092-1.066.93-1.811 1.567-1.811.365 0 .675.212.675.639 0 .888-1.604 1.172-2.242 1.172M26.034.035c-1.293 0-2.205.48-2.897.924L23.1.195h-2.935l-1.549 9.574h3.39l1.076-6.714c.291-.142.73-.338 1.166-.338.329 0 .602.107.602.533 0 .178-.055.498-.073.657l-.948 5.862H27.2l1.039-6.395a9 9 0 0 0 .11-1.207c0-1.28-.602-2.132-2.316-2.132Zm15.46 0c-1.257 0-2.169.373-3.135 1.048C38.011.479 37.32.035 36.262.035c-1.221 0-2.132.48-2.807.96l-.09-.8h-2.9l-1.548 9.574h3.39l1.075-6.714c.292-.142.729-.338 1.166-.338.328 0 .601.107.601.587 0 .124-.036.319-.054.48l-.965 5.985h3.37l1.075-6.714c.31-.16.73-.338 1.148-.338.329 0 .603.107.603.587 0 .124-.038.319-.055.48l-.966 5.985h3.372l1.038-6.395a9 9 0 0 0 .11-1.207c0-1.28-.602-2.132-2.333-2.132Zm8.624 0c-3.773 0-5.413 2.825-5.413 5.844 0 2.29.948 4.12 3.81 4.12C52.376 10 54 6.91 54 3.926c0-2.256-1.04-3.89-3.883-3.89Zm-1.13 7.425c-.601 0-.856-.55-.856-1.44 0-1.172.273-3.463 1.603-3.463.601 0 .802.533.802 1.315 0 1.172-.291 3.588-1.55 3.588Z"}})]),_c('defs',[_c('clipPath',{staticClass:"i-a"},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h54v10H0z"}})])])])
          )
        }
      }
    